import React, { useContext, useState } from 'react';
import { Popover } from 'react-bootstrap';
// import "./PaymentListUser.css";
import AuthContext from 'context/AuthContext';
import PaymentContext from 'context/PaymentContext';
import PurebrandLoader from 'components/Loader/PurebrandLoader';
import { convertUTCToLocal, utcLocalTimeStringConversion } from 'utils/dateFormatter';
import { calculateVideoDuration } from 'utils/dateFormatter';
import { DATE_FORMATS, DEMO_HISTORY_STATUS } from 'utils/constants';
import { success, guestNoShow, backupSuccess, saleCanceled, saleFulfilled, salePending, TechDiffIcon, OffTopicIcon } from 'assets/images';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faHourglassHalf } from '@fortawesome/free-solid-svg-icons';
import { HAS_DISCUSSED_BUSINESS } from 'utils/constants';
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { getRewardTypeLabel } from 'components/Forms/Multistep/constants';

const PaymentListUser = (props) => {
  const { user } = useContext(AuthContext);
  const { payToHostUpdate, payToHostlist, payToHostlistPaid } =
    useContext(PaymentContext);

  const [loading, setLoading] = useState(false);
  const [showExtras, setShowExtras] = useState(false);
  const commission = props?.filters?.commissionFitler || null; // The commission filter
  const statusFilter = props?.filters?.statusFilter || null; // The status filter
  const startDateFilter = props?.filters?.startDate || null; // The start date filter
  const endDateFilter = props?.filters?.endDate || null; // The end date filter
  const FailedStatus = [
    'card_declined',
    'payment_blocked',
    'expired_card',
    'error_creating_intent',
    'payout_failed',
    'failed',
  ];
  const extraGuestSalesEarnings = props?.hostDetails?.extra_guest_earnings || [];

  const mapExtraSaleToEarning = (extraSale) => ({
    sales_commission: extraSale?.sales_commission,
    sales_commission_paid: extraSale?.sales_commission_paid,
    sales_commission_fulfilled_date: extraSale?.sales_commission_fulfilled_date,
    sales_commission_cancellation_date: extraSale?.sales_commission_cancellation_date,
    stripe_sales_payment_status: extraSale?.stripe_sales_payment_status,
    dots_sales_payment_status: extraSale?.dots_sales_payment_status,

    // IMPORTANT: extra guests do NOT have obtained date
    // sales_commission_obtained_date is the earned date
    sales_commission_obtained_date: extraSale?.sales_commission_obtained_date,
  });

  /**
   * @param {string} rewardType - The reward type to get the label for
   * @returns {string} The label for the reward type
   * @description This function normalizes the reward type and returns the label for the reward type
   * @example
   * getRewardTypeLabel('store_credit') // returns 'Store Credit'
   * getRewardTypeLabel('gift_card') // returns 'Gift Card'
   * getRewardTypeLabel('cash') // returns 'Cash'
   * getRewardTypeLabel('unknown') // returns 'Cash'
   * getRewardTypeLabel(null) // returns 'Cash'
   * getRewardTypeLabel(undefined) // returns 'Cash'
   * getRewardTypeLabel('') // returns 'Cash'
   */

  const handleUnpaidPayment = (status, message, type, stats) => {
    setLoading(true);
    const data = {
      status: status,
      message: message,
      type: type,
      payment_status: stats,
    };
    payToHostUpdate(data, props?.hostDetails.id)
      .then(() => {
        payToHostlist('?order=true&paid=false');
        payToHostlistPaid('?order=true&paid=true');
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const getDemoResult = (
    guestAttended,
    scheduledAt,
    startedAt,
    endedAt,
    fallback_hosts_notified,
    salesCommissionData // Add sales commission data as parameter
  ) => {
    // Check for sales commission status
    if (salesCommissionData) {
      const { sales_commission_obtained_date, sales_commission_fulfilled_date, sales_commission_cancelled_date } = salesCommissionData;
  
      if (sales_commission_fulfilled_date) {
        
        return (<div style={{display:'flex', alignContent:'space-around'}}><img src={saleFulfilled} alt="Sale Fulfilled" /> Sale Fulfilled</div>);
      }
  
      if (sales_commission_cancelled_date) {
        return (<div style={{display: 'flex', alignContent:"space-around"}}>
          <img src={saleCanceled} alt="Sale Cancelled" style={{marginRight: 2}} />
        Sale Cancelled
        </div>
      );
      }
  
      if (sales_commission_obtained_date && !sales_commission_fulfilled_date && !sales_commission_cancelled_date) {
        return(
          <div style={{display:'flex', alignContent:'space-around'}}>
          <img src={salePending} alt="Sale Pending" style={{marginRight: 2}}/>
           Sale Pending
          </div>)
      }
    }
  
    // Demo-specific status checks (retain existing logic for demo)
    if (scheduledAt && endedAt) {
      const endedDate = new Date(endedAt);
      const startedDate = startedAt
        ? new Date(startedAt)
        : new Date(scheduledAt);
      const scheduledDate = new Date(scheduledAt);

      let timeDifference;

      if (startedDate < scheduledDate) {
        timeDifference = Math.abs(endedDate - scheduledDate);
      } else {
        timeDifference = Math.abs(endedDate - startedDate);
      }

      if (!guestAttended) {
        if (timeDifference > 600000) {
          return (
            <>
              <img src={guestNoShow} alt='Guest No Show' />{" "}
              {DEMO_HISTORY_STATUS.GUEST_NO_SHOW}
            </>
          );
        } else {
          return (
            <>
              <img src={guestNoShow} alt='Under Time' />{" "}
              {DEMO_HISTORY_STATUS.UNDER_TIME}
            </>
          );
        }
      }

      if (fallback_hosts_notified) {
        return (
          <div style={{display:'flex', alignContent:'space-around'}}>
            <img src={backupSuccess} alt='Back Up Success' style={{marginRight: 4}} />
            {DEMO_HISTORY_STATUS.BACKUP_SUCCESS}
          </div>
        );
      }

      return (
        <>
          <img src={success} alt='Success' />
          {DEMO_HISTORY_STATUS.SUCCESS}
        </>
      );
    }
  
    return '-';
  };
  
  // Modify the existing conditions to include status filtering
const getPaymentStatus = (earning, type) => {
  if ("demo"=== type && earning?.earning_paid !== null) {
    return 'Paid';
  }
  if ("sale"=== type && earning?.sales_commission_paid !== null) {
    return 'Paid';
  }

  if (
    (FailedStatus.includes(earning?.stripe_payment_status) ||
    FailedStatus.includes(earning?.dots_payment_status)) && type === "demo"
  ) {
    return 'Failed';
  }
  if (type === "sale" && (FailedStatus.includes(earning?.stripe_sales_payment_status) || FailedStatus.includes(earning?.dots_sales_payment_status))) {
    return 'Failed';
  }

  return 'Unpaid';
};

// New status filtering logic
const matchesStatusFilter = (statusFilter, earning, type) => {
  if (!statusFilter) return true; // If no status filter, show all
  
  const currentStatus = getPaymentStatus(earning, type);
  return currentStatus.toLowerCase() === statusFilter.toLowerCase();
};

  if (loading) {
    return <PurebrandLoader />;
  }

  const shouldDisplayDemoRow = commission?.toLowerCase() === 'demo' || commission?.toLowerCase() === 'no-show';
  const shouldDisplayBothRow = commission?.toLowerCase() !== 'demo' && commission?.toLowerCase() !== 'sales' && commission?.toLowerCase() !== 'no-show';
  const isSalesCommissionValid = props?.hostDetails?.earning?.sales_commission !== '0.00'
  const shouldDisplaySalesRow = commission?.toLowerCase() === 'sales' && isSalesCommissionValid; // Add condition for sales_commission

  const CalculateDate = (dateObject, type) => {
    if (type === 'sale earned') {
      if (dateObject?.sales_commission_cancellation_date || FailedStatus.includes(dateObject?.stripe_payment_status) || FailedStatus.includes(dateObject?.dots_payment_status)) {
        return 'NA';
      
      } else if (dateObject?.sales_commission_obtained_date) {
        return (utcLocalTimeStringConversion(
          dateObject?.sales_commission_obtained_date
        ) !== 'Invalid date' ? utcLocalTimeStringConversion(
          dateObject?.sales_commission_obtained_date
        ) : '-');
      } else{
        return 'Pending';
      }
    }else if(type === "demo earned"){
      return (utcLocalTimeStringConversion(dateObject?.ended_at) !=="Invalid date"? utcLocalTimeStringConversion(
        dateObject?.ended_at
      ): "NA");
    }
    else if(type === "demo date"){
      return (utcLocalTimeStringConversion(dateObject?.scheduled_date)!=="Invalid date"? utcLocalTimeStringConversion(
                          `${dateObject?.scheduled_date}T${dateObject?.scheduled_time}Z`
                        ): "NA");
    }else if (type === "demo paid"){
      return (dateObject?.earning <= 0 ? "NA": utcLocalTimeStringConversion(dateObject?.earning_paid)!=="Invalid date"? utcLocalTimeStringConversion(dateObject?.earning_paid): "Pending");
    }else if(type === "sale paid"){

      if (dateObject?.sales_commission_cancellation_date) {
        return "NA";
      
      } else if (dateObject?.sales_commission_paid) {
        return utcLocalTimeStringConversion(
          dateObject?.sales_commission_paid
        ) !== "Invalid date"
          ? utcLocalTimeStringConversion(dateObject?.sales_commission_paid)
          : "-";
      } else {
        return "Pending";
      }
    }else{
      console.log("Could not calculate the date:", type, dateObject);
      return "NA";
    }

  };
  const matchesDateFilter = (startDate) => {
    if(!startDateFilter && !endDateFilter ) return true;
    const startDateFormatted = moment(startDate).format('YYYY-MM-DD')
    return startDateFormatted >= startDateFilter && startDateFormatted <= endDateFilter;

  }

 

  const demoResult = (dataList, schedule, type = 'demo') => {
    if (dataList?.is_obscene_content) {
      return (
        <>
          <FontAwesomeIcon icon={faBan} style={{ color: "#dc3545", marginRight: 4 }} />
          {DEMO_HISTORY_STATUS.OBSCENE_CONTENT}
        </>
      );
    }
    const discussionStatus = dataList?.has_discussed_business_status;
     const primaryJoined = dataList?.members?.guest_detail?.attend_meeting;

    const extraJoined = dataList?.members?.extra_guests?.some(
      g => g?.guest_detail?.attend_meeting
    );

    const anyGuestJoined = primaryJoined || extraJoined;
  
    // Handle business discussion statuses (for 'demo' only)
    if (type === 'demo' && discussionStatus !== HAS_DISCUSSED_BUSINESS.NA) {
      if (discussionStatus === HAS_DISCUSSED_BUSINESS.NI || discussionStatus === HAS_DISCUSSED_BUSINESS.IP) {
        return (
          <div style={{ display: "flex", alignItems: "center", marginLeft: "3px" }}>
            <FontAwesomeIcon
              icon={faHourglassHalf}
              style={{ color: "#FFD43B", paddingRight: 4, marginRight: 4 }}
            />
            {DEMO_HISTORY_STATUS.PROCESSING}
          </div>
        );
      }
  
      if (discussionStatus === HAS_DISCUSSED_BUSINESS.FIN) {
        if (dataList?.has_discussed_business === true) {
          if (dataList?.fallback_hosts_notified) {
            return (
              <>
                <img src={backupSuccess} alt='Back-Up Success' />{" "}
                {DEMO_HISTORY_STATUS.BACKUP_SUCCESS}
              </>
            );
          }
          return (
            <>
              <img src={success} alt="Success" /> {DEMO_HISTORY_STATUS.SUCCESS}
            </>
          );
        } else if (dataList?.technical_difficulties) {
          return (
            <>
              <img
                src={TechDiffIcon}
                alt="TECH DIFF"
                style={{ width: '20px', height: '20px' }}
              />{" "}
              {DEMO_HISTORY_STATUS.TECH_DIFF}
            </>
          );
        } else {
          return (
            <>
              <img
                src={OffTopicIcon}
                alt="OFF TOPIC"
                style={{ width: "20px", height: "20px" }}
              />{" "}
              {DEMO_HISTORY_STATUS.OFF_TOPIC}
            </>
          );
        }
      }
  
      return null; // If status is not matched above
    }
  
    // Use getDemoResult logic for 'sales' and fallback 'demo'
    return getDemoResult(
      anyGuestJoined,
      `${schedule?.scheduled_date}T${schedule?.scheduled_time}Z`,
      dataList?.started_at,
      dataList?.ended_at,
      dataList?.fallback_hosts_notified,
      type === 'sales'
        ? {
            sales_commission_obtained_date: dataList?.earning?.sales_commission_obtained_date,
            sales_commission_fulfilled_date: dataList?.earning?.sales_commission_fulfilled_date,
            sales_commission_cancelled_date: dataList?.earning?.sales_commission_cancellation_date,
          }
        : dataList?.status,
      dataList?.absent_host_details
    );
  };
  
  return (
    <>
      {/* Demo Commission Row */}
      {(shouldDisplayBothRow || shouldDisplayDemoRow) && matchesStatusFilter(statusFilter, props?.hostDetails?.earning, "demo") && matchesDateFilter(props?.hostDetails?.ended_at) // use ended_at instead of scheduled at.
      && (
        <tr>
          <td><p>{props?.hostDetails?.members?.host_detail?.first_name} {props?.hostDetails?.members?.host_detail?.last_name.charAt(0)}.</p></td>
          <td className='table-product'><p>{props?.hostDetails?.product?.name}</p></td>
          <td><p>${props?.hostDetails?.earning?.earning}</p></td>
          <td><p>{getPaymentStatus(props?.hostDetails?.earning, "demo")}</p></td>
          {/* <td><p>{getPaymentStatus(props?.hostDetails?.earning, 'demo')}</p></td> */}
          <td><p>Video meeting</p></td>
          <td className='table-result'><p>{demoResult(props?.hostDetails, props?.hostDetails?.schedule,'demo')}</p></td>
          <td><p>{calculateVideoDuration(props?.hostDetails?.started_at, props?.hostDetails?.ended_at, props?.hostDetails?.members?.guest_detail?.attend_meeting, props?.hostDetails?.members?.guest_detail?.left_meeting, `${props?.hostDetails?.schedule?.scheduled_date}T${props?.hostDetails?.schedule?.scheduled_time}`)}</p></td>
          <td onClick={(e) => e.stopPropagation()}>
            {/* Primary guest */}
            <p>{props?.hostDetails?.members?.guest_detail?.full_name || '-'}

            {/* Extra guest tooltip */}
            {props?.hostDetails?.members?.extra_guests?.length > 0 && (
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip id="tooltip-extra-guests" className="extra-guest-tooltip">
                    {props.hostDetails.members.extra_guests.map((g, i) => (
                      <div key={i}>{g?.guest_detail?.full_name}</div>
                    ))}
                  </Tooltip>
                }
              >
                <span
                  style={{
                    marginLeft: 6,
                    color: "#0d6efd",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: 500
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  +{props?.hostDetails?.members?.extra_guests?.length}
                </span>
              </OverlayTrigger>
            )}</p>
          </td>
          <td><p>{CalculateDate(props?.hostDetails, "demo earned")}</p></td>
          <td><p>{CalculateDate(props?.hostDetails?.schedule, "demo date")}</p></td>
          <td><p>{CalculateDate(props?.hostDetails?.earning, "demo paid")}</p></td>
          <td><p>{getRewardTypeLabel(props?.hostDetails?.host_reward_type)}</p></td>
        </tr>
      )}

      {/* Sales Commission Row */}
      {(shouldDisplayBothRow  || shouldDisplaySalesRow) && isSalesCommissionValid && matchesStatusFilter(statusFilter, props?.hostDetails?.earning, "sale") && matchesDateFilter(props?.hostDetails?.earning?.sales_commission_obtained_date) && (
  <tr>
    <td><p>{props?.hostDetails?.members?.host_detail?.first_name} {props?.hostDetails?.members?.host_detail?.last_name.charAt(0)}.</p></td>
    <td className='table-product'><p>{props?.hostDetails?.product?.name}</p></td>
    <td><p>{(props?.hostDetails?.earning?.sales_commission_obtained_date && !props?.hostDetails?.earning?.sales_commission_fulfilled_date && !props?.hostDetails?.earning?.sales_commission_cancellation_date) ? "TBD" :`$${props?.hostDetails?.earning?.sales_commission}`}</p></td>
    <td><p>{getPaymentStatus(props?.hostDetails?.earning, "sale")}</p></td>
    {/* <td><p>{getPaymentStatus(props?.hostDetails?.earning, 'sales')}</p></td> */}
    <td><p>Sales</p></td>
    <td className='table-result'><p>{demoResult(
      props?.hostDetails, props?.hostDetails?.schedule, 'sales'
    )}</p></td>
    <td><p>{calculateVideoDuration(props?.hostDetails?.started_at, props?.hostDetails?.ended_at, props?.hostDetails?.members?.guest_detail?.attend_meeting, props?.hostDetails?.members?.guest_detail?.left_meeting, `${props?.hostDetails?.schedule?.scheduled_date}T${props?.hostDetails?.schedule?.scheduled_time}`)}</p></td>
    <td onClick={(e) => e.stopPropagation()}>
      {/* Primary guest */}
      <p>{props?.hostDetails?.members?.guest_detail?.full_name || '-'}</p>
    </td>
    <td><p>{CalculateDate(props?.hostDetails?.earning, "sale earned")}</p></td>
    <td><p>{CalculateDate(props?.hostDetails?.schedule, "demo date")}</p></td>
    <td><p>{CalculateDate(props?.hostDetails?.earning, "sale paid")}</p></td>
    <td><p>{getRewardTypeLabel(props?.hostDetails?.host_reward_type)}</p></td>
  </tr>
)}
{/* Extra Guests Sales Commission Rows */}
{(shouldDisplayBothRow || shouldDisplaySalesRow) &&
  extraGuestSalesEarnings?.length > 0 &&
  extraGuestSalesEarnings.map((extraSale, idx) => {
    const extraSaleValid = extraSale?.sales_commission !== "0.00";

    // if no commission, don't show row
    if (!extraSaleValid) return null;

    // apply date filter (same as primary sales)
    if (startDateFilter && endDateFilter) {
      const filterDate = moment(extraSale?.sales_commission_obtained_date).format("YYYY-MM-DD");
      if (filterDate < startDateFilter || filterDate > endDateFilter) {
        return null;
      }
    }

    return (
      <tr key={`extra-sale-${idx}`}>
        <td>
          <p>
            {props?.hostDetails?.members?.host_detail?.first_name}{" "}
            {props?.hostDetails?.members?.host_detail?.last_name.charAt(0)}.
          </p>
        </td>

        <td className="table-product">
          <p>{props?.hostDetails?.product?.name}</p>
        </td>

        <td>
          <p>
            {(extraSale?.sales_commission_order_status &&
              extraSale?.sales_commission_order_status !== "fulfilled" &&
              !extraSale?.sales_commission_cancellation_date)
              ? "TBD"
              : `$${extraSale?.sales_commission}`}
          </p>
        </td>

        <td>
          <p>
            {/* Status logic for extra guest sale */}
            {getPaymentStatus(mapExtraSaleToEarning(extraSale), "sale")}
          </p>
        </td>

        <td>
          <p>Sales</p>
        </td>

        <td className="table-result">
          <p>
            {demoResult(
              { earning: mapExtraSaleToEarning(extraSale) },
              props?.hostDetails?.schedule,
              "sales"
            )}
          </p>
        </td>

        <td>
          <p>
            {calculateVideoDuration(
              props?.hostDetails?.started_at,
              props?.hostDetails?.ended_at,
              props?.hostDetails?.members?.guest_detail?.attend_meeting,
              props?.hostDetails?.members?.guest_detail?.left_meeting,
              `${props?.hostDetails?.schedule?.scheduled_date}T${props?.hostDetails?.schedule?.scheduled_time}`
            )}
          </p>
        </td>

        {/* Guest Column = Extra Guest Name */}
        <td onClick={(e) => e.stopPropagation()}>
          <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
            <div>
              <p>{extraSale?.sales_guest?.full_name || "-"}</p>
            </div>
          </div>
        </td>

        <td>
          <p>
            {CalculateDate(mapExtraSaleToEarning(extraSale), "sale earned")}
          </p>
        </td>


        <td>
          <p>{CalculateDate(props?.hostDetails?.schedule, "demo date")}</p>
        </td>

        <td>
          <p>
            {CalculateDate(mapExtraSaleToEarning(extraSale), "sale paid")}
          </p>
        </td>

        <td>
          <p>{getRewardTypeLabel(props?.hostDetails?.host_reward_type)}</p>
        </td>
      </tr>
    );
  })}
    </>
  );
};

export default PaymentListUser;
